<div class="page_container">
  <header class="header">
    <div class="close_btn" (click)="goBack()" *ngIf="routerNavigationAllowed">
      <img src="assets/icons/back_button.svg" alt="back icon" />
    </div>
    <div class="page_title">Tariff</div>
    <button
      class="tertiary_button add_new_btn"
      (click)="addNewTariff()"
      *RequiresPermission="{permissionIds: [PermissionConstants.CHARGE.EDIT_TARIFF]}">
      Add New
    </button>
  </header>
  <!--  <app-stats-horizontal
      [stats]="chargeStats"
    ></app-stats-horizontal>-->
  <app-tos-table
    *RequiresPermission="{permissionIds: [PermissionConstants.CHARGE.VIEW_TARIFF]}; fallback: true"
    [showTableStats]="false"
    [defaultFilters]="defaultFilters"
    [tableMeta]="tableMeta"
    [tableMenuOptions]="menuOptions"
    [(dataListRequest)]="tableListRequest"
    [dataListResponse]="tableListData"
    [(selectedItems)]="selectedItems"
    (tosTableAction)="getTableList()"
    (tableMenuOptionSelected)="handleOptionSelected($event)"
  ></app-tos-table>
</div>

<ng-template #tariffCloneTemplate let-data>
  <form [formGroup]="tariffCloneForm" style="display: flex;flex-direction: column;gap: 24px;">
    <div class="form_row">
      <div class="form_group">
        <label for="fromDate" class="required_field_label">From</label>
        <app-date-picker
          id="fromDate"
          [type]="'datetime-local'"
          [formControlName]="'fromDate'"
          [defaultToCurrentDate]="true"
        ></app-date-picker>
        <div
          class="form_validation_error"
          [ngClass]="{'visible': tariffCloneForm.get('fromDate')?.invalid && tariffCloneForm.get('fromDate')?.touched}"
        >
          <small *ngIf="tariffCloneForm.get('fromDate')?.errors?.['required']"
          >From Date is required</small
          >
        </div>
      </div>
      <div class="form_group">
        <label for="toDate" class="required_field_label">To</label>
        <app-date-picker
          id="toDate"
          [type]="'datetime-local'"
          [formControlName]="'toDate'"
        ></app-date-picker>
        <div
          class="form_validation_error"
          [ngClass]="{'visible': tariffCloneForm.get('toDate')?.invalid && tariffCloneForm.get('toDate')?.touched}"
        >
          <small *ngIf="tariffCloneForm.get('toDate')?.errors?.['required']"
          >To Date is required</small
          >
        </div>
      </div>
    </div>
    <div class="form_row">
      <div class="form_group">
        <label for="description" class="">Description</label>
        <textarea id="description" placeholder="Enter Description" formControlName="description"></textarea>
      </div>
    </div>
    <div class="action_btns">
      <div class="btn secondary_button" (click)="closeModal()">Cancel</div>
      <div class="btn primary_button" (click)="cloneTariff(data.tariffCloneData)">Save</div>
    </div>
  </form>
</ng-template>
